import React from "react";
import { Siren } from "lucide-react";
import { warnaEws, ringkasHet, ikonKomoditas } from "../lib/ews";

/**
 * Tabel status EWS (Early Warning System) pada menu Buat Pesanan.
 * Menampilkan seluruh komoditas pantauan sekaligus — status EWS dan status
 * HET/HAP menyatu dalam satu lencana yang warnanya mengikuti status EWS.
 * Pada layar lebar tabelnya dibagi dua kolom agar tidak terlalu memanjang.
 */
/** Ikon komoditas: emoji, atau <img> bila nilainya berupa path berkas. */
export function IkonKomoditas({ nama, className = "w-4 h-4" }) {
  const ikon = ikonKomoditas(nama);
  if (typeof ikon === "string" && ikon.startsWith("/")) {
    return <img src={ikon} alt="" aria-hidden="true" className={`${className} object-contain shrink-0`} />;
  }
  return (
    <span className={`${className} inline-flex items-center justify-center text-sm leading-none shrink-0`} aria-hidden="true">
      {ikon}
    </span>
  );
}

export default function EwsTable({ items }) {
  const baris = items || [];
  const adaIsi = baris.some((i) => i.status_ews || i.het_status || i.het_persen);
  if (!adaIsi) return null;

  const tengah = Math.ceil(baris.length / 2);
  const kolom = [baris.slice(0, tengah), baris.slice(tengah)].filter((k) => k.length);

  return (
    <div className="kedan-card w-full overflow-hidden" data-testid="ews-table">
      <div className="flex items-center gap-3 border-b !border-amber-200 !bg-amber-50 px-4 py-2">
        <span className="inline-flex items-center gap-1.5 shrink-0 rounded-full border border-amber-200 bg-amber-100 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-amber-800">
          <Siren className="w-3.5 h-3.5 shrink-0" />
          Status<span className="hidden sm:inline">&nbsp;Harga Terkini</span>
        </span>
        <span className="text-[11px] text-amber-800 leading-snug">
          Lakukan subtitusi/pembelian komoditas lainnya apabila harga berstatus tinggi/sangat tinggi.
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 md:divide-x divide-slate-100">
        {kolom.map((isi, idx) => (
          <table key={idx} className="w-full text-xs">
            <tbody>
              {isi.map((i) => {
                const het = ringkasHet(i.het_persen, i.het_status);
                // Dua kartu bertumpuk dengan lebar tetap agar seluruh baris sejajar.
                const warna = warnaEws(i.status_ews);
                return (
                  <tr key={i.komoditas} className="border-b border-slate-100 last:border-0">
                    <td className="px-4 py-2 font-medium text-slate-700 whitespace-nowrap align-middle">
                      <span className="inline-flex items-center gap-2">
                        <IkonKomoditas nama={i.komoditas} />
                        {i.komoditas}
                      </span>
                    </td>
                    <td className="px-4 py-2 align-middle">
                      {/* Satu kartu, isinya dua baris: status EWS di atas,
                          status HET/HAP di bawah. */}
                      <div
                        className={`ml-auto w-44 rounded-md border px-2 py-1 text-center text-[10px] leading-tight ${warna}`}
                        title={`${i.status_ews || "Status EWS belum diisi"} · ${het || "HET/HAP belum diisi"}`}
                      >
                        <div className="font-semibold truncate">{i.status_ews || "—"}</div>
                        <div className="mt-0.5 border-t border-black/10 pt-0.5 font-medium truncate">
                          {het || "— HET/HAP"}
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ))}
      </div>
    </div>
  );
}
